<template lang="pug">
.sep-event
  .d-flex.justify-content-center.align-items-center(v-if="!isLoggedIn")
    img.pointer(src="/images/event/september2025/home/before-login-title.png" @click="$router.push('/event').catch(err => {})")
  .lucky-container(v-else)
    .d-flex.justify-content-center.align-items-center.flex-column.mt-3
      img.w-75(src="/images/event/september2025/home/epicwin-4D-lucky-number.png")
      .position-relative.w-75
        img.pointer(src="/images/event/september2025/home/total-prize-for-desktop.png" @click="$router.push('/event').catch(err => {})")
    template(v-if="resToday.length>0")
      .desktop
        .position-relative
          img(src="/images/event/september2025/home/winning-list-for-desktop.png")
          .position-absolute.winning-title
            img(src="/images/event/september2025/home/4d-winning-number-text.png")
          .position-absolute.number-4d.text-center
            .d-grid.number-div
              p(v-for="res in finalRes") {{res.number}}
          template(v-if="numToday.length>0")
            .position-absolute.d-flex.justify-content-evenly.text-center.w-100.get4d-btn2
              img.pointer(src="/images/event/september2025/home/check-my-num.png" @click="goEvent")
              img.pointer(src="/images/event/september2025/home/get-my-4d-number-for-desktop.png" @click="depoAct")
          template(v-else)
            .position-absolute.get4d-btn.pointer(@click="depoAct")
              img(src="/images/event/september2025/home/get-my-4d-number-for-desktop.png")
      .container.mobile
        img.w-75(src="/images/event/september2025/home/4d-win-mobile.png")
        .position-relative
          img(src="/images/event/september2025/home/WINNING-LIST-FOR-MAIN-PAGE.png")
          .position-absolute.number-4d.text-center
            .d-grid.number-div
              p(v-for="res in finalRes") {{res.number}}
        template(v-if="numToday.length> 0")
          .d-flex.justify-content-center
            img.w-50.mt-2.mb-3(src="/images/event/september2025/home/CHECK-MY-4D-NUM.png" @click="$router.push('/event').catch(err => {})")
            img.w-50.mt-2.mb-3(src="/images/event/september2025/home/GET-MY-4D-NUM.png" @click="$router.push('/event').catch(err => {})")
        template(v-else)
          img.w-50.mt-2.mb-3(src="/images/event/september2025/home/GET-MY-4D-NUM.png" @click="$router.push('/event').catch(err => {})")
    template(v-else)
      .desktop
        .position-relative
          img(src="/images/event/september2025/home/winning-list-for-desktop.png")
          .position-absolute.winning-title
            img(src="/images/event/september2025/home/4d-winning-number-text.png")
          .position-absolute.date-4d.text-center
            .top Winning Announcement Date:
            .bottom 12AM {{$moment().add(1, 'day').format("D MMMM").toUpperCase()}}
          template(v-if="numToday.length>0")
            .position-absolute.d-flex.justify-content-evenly.text-center.w-100.get4d-btn2
              img.pointer(src="/images/event/september2025/home/check-my-num.png" @click="$router.push('/event').catch(err => {})")
              img.pointer(src="/images/event/september2025/home/get-my-4d-number-for-desktop.png" @click="depoAct")
          template(v-else)
            .position-absolute.get4d-btn.pointer(@click="$router.push('/event').catch(err => {})")
              img(src="/images/event/september2025/home/get-my-4d-number-for-desktop.png" @click="depoAct")
      .container.mobile
        img.w-75(src="/images/event/september2025/home/4d-win-mobile.png")
        .position-relative
          img(src="/images/event/september2025/home/WINNING-LIST-FOR-MAIN-PAGE.png")
          .position-absolute.date-4d.text-center
            .top Winning Announcement Date:
            .bottom 12AM {{$moment().add(1, 'day').format("D MMMM").toUpperCase()}}
        template(v-if="numToday.length> 0")
          .d-flex.justify-content-center
            img.w-50.mt-2.mb-3(src="/images/event/september2025/home/CHECK-MY-4D-NUM.png" @click="$router.push('/event').catch(err => {})")
            img.w-50.mt-2.mb-3(src="/images/event/september2025/home/GET-MY-4D-NUM.png" @click="$router.push('/event').catch(err => {})")
        template(v-else)
          img.w-50.mt-2.mb-3(src="/images/event/september2025/home/GET-MY-4D-NUM.png" @click="$router.push('/event').catch(err => {})")
</template>
<script>
export default{
  data(){
    return{
      startRender:false,
      goDepo:true,
      showWinner: false,
      showToday:true,
      checkRes: false,
      checkToday: true,
      checkPrev: false,
      numToday:[],
      numPrev: [],
      resToday:[],
      resPrev:[]
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    finalRes(){
      const arr = [...this.resToday]
      while (arr.length < 10) {
        arr.push({ number: '-' }) // placeholder
      }
      return arr
    }
  },
  mounted(){
    this.getNumbers()
    this.getWinners()
  },
  methods:{
    getNumbers(){
      if (this.sessionToken) {
        this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getNumbers", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.numToday = response.data.filter(item => this.$moment(item.working_date).format("YYYY-MM-DD") === this.$moment().format("YYYY-MM-DD"))
                this.numPrev = response.data.filter(item => this.$moment(item.working_date).format("YYYY-MM-DD") === this.$moment().subtract(1, 'day').format("YYYY-MM-DD"))
                this.goDepo = false
              }else{
                this.goDepo = true
              }
              this.startRender = false
            } else {
              this.startRender = false
              this.goDepo = true
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            this.startRender = false
            this.goDepo = true
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    getWinners(){
      if (this.sessionToken) {
        this.resPrev = []
        this.resToday = []
        this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getWinners", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.resToday = response.data.filter(item => this.$moment(item.working_date).format("YYYY-MM-DD") === this.$moment().subtract(1, 'day').format("YYYY-MM-DD"))
                this.resPrev = response.data.filter(item => this.$moment(item.working_date).format("YYYY-MM-DD") === this.$moment().subtract(2, 'day').format("YYYY-MM-DD"))
                this.showWinner = true
              }else{
                this.showWinner = false
              }
              this.startRender = false
            } else {
              this.startRender = false
              this.showWinner = false
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            this.startRender = false
            this.showWinner = false
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    goEvent(){
      this.$router.push({
        name:"event",
        params:{
          "checkResult": true
        }
      }).catch(error =>{})
    },
    depoAct(){
      if(this.isLoggedIn){
				this.$router.push("/deposit").catch(err => {});
			}else{
				this.$router.push("/login").catch(err => {});
			}
    }
  }
}
</script>
<style lang="css" scoped>
.get4d-btn{
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
}
.get4d-btn2{
  bottom: -15px;
}
.winning-title{
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  width: 75%;
}
.date-4d{
  top: 40%;
  transform: translateY(-50%);
  left: 50%;
  transform: translateX(-50%);
  font-size: 20px;
  width: 100%;
}
.top{
  font-family: "Montserrat";
  font-weight: bold;
}
.bottom{
  font-family: "Montserrat";
  font-weight: bold;
  color: #f0ff4e;
}

.lucky-container{
  display: flex;
  justify-content: center;
  align-items: center;
}

.desktop{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.mobile{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.number-div{
  grid-template-columns: repeat(5, 1fr);
}

.number-4d{
  top: 40%;
  transform: translateY(-50%);
  left: 50%;
  transform: translateX(-50%);
  font-size: 20px;
  width: 100%;
  font-family: "Montserrat";
  font-weight: bold;
}

@media (min-width: 941px){
  .mobile{
    display:none
  }
}
@media (max-width: 940px){
  .desktop{
    display:none
  }
  .lucky-container{
    flex-direction: column;
  }
  .date-4d{
    top:25%;
    font-size: 14px;
    width: 100%;
  }
  .number-4d{
    top:15%;
    font-size: 12px;
    width: 70%;
  }
}
</style>